import usePageTracking from "../../utils/gtm-page-tracking";



const ThankYou = () => {
    usePageTracking();

    return (
        <section id="thank-you">
            <div className="container-fluid mb-5">
                <div className="row gg-bg-gradient-h align-items-center justify-content-center text-white py-5">
                    <div className="col-lg-8 text-center">
                        <h1 className="display-4 fw-bold">
                            Thank You!
                        </h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ThankYou;